import axios from "axios";
import { Message } from "element-ui";
import cookie from "./cookie";
import router from "@/router";
const config = require("../../config");

function getService() {
  let service = axios.create({
    baseURL: `${
      process.env.NODE_ENV == "development" ? "" : config.API_BASE
    }/api`,
    timeout: 15000
  });

  // 前置拦截器
  service.interceptors.request.use(
    conf => {
      conf.headers[config.WEB == 1 ? "admin-token" : "user-token"] = cookie.getToken();
      conf.headers["client-type"] = config.WEB;
      return conf;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // 后置拦截器
  service.interceptors.response.use(
    response => {
      const res = response.data;

      if (response.data.code != 1) {
        if (response.data.code === "400001") {
          cookie.removeToken();
					if(!location.pathname.includes('/login')){
						router.replace(
							`/login?forward=${encodeURIComponent(window.location.href)}`
						);
					}
					return Promise.reject('未登录');
        }
        Message({ message: response.data.message, type: "error" });
        return Promise.reject(res.message || "error");
      } else {
        return Promise.resolve(response);
      }
    },
    error => {
      console.log("err" + error); // for debug
      Message({
        message: error.message,
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(error);
    }
  );
  return service;
}

// get请求
const get = (url, args, type) => {
  let service = getService(type);
  return service({
    url,
    method: "get",
    params: args
  }).then(response => {
    return response.data;
  });
};

// post请求
const post = (url, args, type) => {
  let service = getService(type);
  return service({
    url,
    method: "post",
    data: args
  }).then(response => {
    return response.data;
  });
};

export default {
  get,
  post
};
